import React, { useState, useEffect } from "react";
import moment from "moment-timezone";
import clsx from "clsx";

const MAX_WAIT_MINUTES = 99;
const OVERFLOW_DISPLAY_TEXT = "100+";

const calculateWaitMinutes = (requestedDate, timeZone) => {
  const requested = moment.utc(requestedDate).tz(timeZone);
  const now = moment().tz(timeZone);
  return Math.floor(now.diff(requested, "minutes"));
};

const WaitTimeCell = ({ requestedDate, timeZone, getTierColor, classes }) => {
  const [waitMinutes, setWaitMinutes] = useState(() =>
    calculateWaitMinutes(requestedDate, timeZone)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setWaitMinutes(calculateWaitMinutes(requestedDate, timeZone));
    }, 60000);
    return () => clearInterval(interval);
  }, [requestedDate, timeZone]);

  const displayText = waitMinutes > MAX_WAIT_MINUTES ? OVERFLOW_DISPLAY_TEXT : String(waitMinutes);
  const backgroundColor = getTierColor?.(waitMinutes);

  return (
    <span
      className={clsx(classes.waitTimeLabel, backgroundColor && classes.waitTimeLabelColored)}
      style={{ backgroundColor }}
    >
      {displayText}
    </span>
  );
};

export default WaitTimeCell;
